import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenUpdateAction from './communityGardenUpdate.action.json' with { type: 'json' }
import { communityGardenObject } from '../communityGardenObject'

const communityGardenUpdateDefinition = defineAction({
  ...communityGardenUpdateAction,

  input: communityGardenObject
    .pick({
      id: true,
      title: true,
      address: true,
      latitude: true,
      longitude: true,
      observation: true,
      area: true,
      bedsCount: true,
    })
    .partial()
    .required({ id: true }),
  output: z.object({}),
})

export default communityGardenUpdateDefinition
